/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Royal_Extra_Badger_RaceInputs */

const fr_royal_extra_badger_race = /** @type {(inputs: Royal_Extra_Badger_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo mis à jour`)
};

/**

* @param {Royal_Extra_Badger_RaceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const royal_extra_badger_race = /** @type {((inputs?: Royal_Extra_Badger_RaceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Royal_Extra_Badger_RaceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_royal_extra_badger_race(inputs)
});